import { Link, Spacer, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";
import type { TwoFactorAuthenticationMethods } from "@shared/types/graphqlGenerated";

interface Props {
  otpMethod: TwoFactorAuthenticationMethods;
  onClick: () => void;
}

const BackupCodeSignInLink = ({ otpMethod, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="footnote" isMarginless intention="neutral" colorIntensity="subtle">
        {t(l.mfa.VerifyMFAForm.unableToAccessOtpMethod[otpMethod])}
      </Typography>
      <Spacer size="small" />
      <Typography variant="footnote" intention="neutral" colorIntensity="subtle">
        <Link onClick={onClick}>{t(l.mfa.VerifyMFAForm.useBackupCodeToSignIn)}</Link>
      </Typography>
      <Spacer size="large" />
    </>
  );
};

export { BackupCodeSignInLink };
